import React from 'react';
import PropTypes from 'prop-types';
import EntryHyperlinkMap from './entry-hyperlink-map';
import convertJsonToPropsInLocale from './convert-json-to-props-in-locale';

const defaultLocale = 'en-US';

const EntryHyperlink = ({ target, children }) => {
  const { sys: { contentType, contentful_id: targetId } } = target;
  // console.log('link target contentful id', targetId);
  if (contentType) {
    const { sys: { id } } = contentType;
    // console.log('contentful entry id', id);
    // console.log('contentful entry fields', target.fields);
    const Component = EntryHyperlinkMap[id];
    if (Component) {
      const props = convertJsonToPropsInLocale(target.fields, defaultLocale);
      // console.log(`props for ${id}`, props);
      return <Component targetId={targetId} {...props}>{children}</Component>;
    }
  }
  return children;
};

EntryHyperlink.propTypes = {
  target: PropTypes.shape({
    sys: PropTypes.shape({
      contentType: PropTypes.shape({
        sys: PropTypes.shape({
          id: PropTypes.string.isRequired,
        }).isRequired,
      }),
    }).isRequired,
    fields: PropTypes.object.isRequired,
  }).isRequired,
};

export default EntryHyperlink;
